import { motion } from "framer-motion";
import { VEHICLES } from "@/lib/api";

const slug = (v) => v.toLowerCase().replace(/[^a-z]+/g, "-");

export const RoleToggle = ({ role, setRole }) => (
  <div className="grid grid-cols-2 gap-2 rounded-2xl bg-[#F0F5FD] p-1.5" role="tablist">
    {[["driver", "I want to drive", "waitlist-role-driver-btn"], ["customer", "I want deliveries", "waitlist-role-customer-btn"]].map(([k, label, id]) => (
      <button key={k} type="button" onClick={() => setRole(k)} data-testid={id} className="relative rounded-xl py-3 text-sm sm:text-base font-bold">
        {role === k && <motion.span layoutId="role-pill" className="absolute inset-0 rounded-xl bg-[#13296B]" transition={{ type: "spring", stiffness: 400, damping: 32 }} />}
        <span className={`relative transition-colors duration-300 ${role === k ? "text-white" : "text-[#13296B]"}`}>
          {label}
          {k === "driver" && <span className="ml-2 hidden sm:inline rounded-full bg-[#2F7FF0] px-2 py-0.5 text-[11px] text-white align-middle">Priority</span>}
        </span>
      </button>
    ))}
  </div>
);

export const VehicleChips = ({ value, onChange }) => (
  <div>
    <p className="text-sm font-semibold text-[#13296B] mb-3">What do you drive?</p>
    <div className="flex flex-wrap gap-2">
      {VEHICLES.map((v) => (
        <motion.button
          key={v}
          type="button"
          whileTap={{ scale: 0.94 }}
          onClick={() => onChange(v)}
          data-testid={`waitlist-vehicle-chip-${slug(v)}`}
          className={`rounded-full px-4 py-2.5 text-sm font-semibold border-2 transition-colors duration-200 ${value === v ? "bg-[#2F7FF0] border-[#2F7FF0] text-white" : "border-slate-200 text-slate-700 hover:border-[#2F7FF0]"}`}
        >
          {v}
        </motion.button>
      ))}
    </div>
  </div>
);

export const Field = ({ label, testId, ...props }) => (
  <label className="block">
    <span className="text-sm font-semibold text-[#13296B]">{label}</span>
    <input data-testid={testId} {...props} className="mt-2 w-full rounded-xl border-2 border-slate-200 bg-white px-4 py-3 text-base text-[#0B1938] outline-none focus:border-[#2F7FF0] transition-colors duration-200" />
  </label>
);
